<template>
  <el-row>
    <el-col>
      <div class="form-module-tit">{{ $locale('movie.other') }}</div>
      <el-form-item :label="$locale('global.hiddenSetting')">
        <div class="elg-tag-group">
          <template v-for="btn in unDisplayBtns">
            <el-button
              :class="formData[btn.value] ? 'egl-btn-white-gray-border act' : 'egl-btn-white-gray-border'"
              @click="undisplay_fn(btn.value)"
              :key="btn.value"
              tabindex="0"
              hidefocus="true"
            >{{ btn.label }}</el-button>
          </template>
        </div>
      </el-form-item>
      <el-form-item :label="$locale('movie.openStartingDay')" prop="openWeekStartDay">
        <el-select v-model="formData.openWeekStartDay">
          <el-option
            v-for="item in weekOptions"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item :label="$locale('movie.resetDays4Week')" prop="resetDays4Week">
        <el-input
          :placeholder="$locale('movie.plsEnterResetDays4Week')"
          v-model.number="formData.resetDays4Week"
          maxlength="5"
        ></el-input>
      </el-form-item> -->
      <el-form-item :label="$locale('movie.sorting2')" prop="sort">
        <el-input
          :placeholder="$locale('form.plsEnterSorting')"
          v-model.number="formData.sort"
          maxlength="5"
        ></el-input>
      </el-form-item>
    </el-col>
  </el-row>
</template>

<script>
import { unDisplayBtns } from "@/assets/js/movieStatic";
import { weekSelectArrayForMovie } from "@/utils/common";

export default {
  name: "sales-settings",
  props: {
    formData: {
      required: true,
      type: Object,
    },
    formRef: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      unDisplayBtns,
    };
  },
  computed: {
    weekOptions() {
      let optionsArray = [ ...weekSelectArrayForMovie ];
      let dictionary = window.localStorage.getItem("dictionary");

      if (dictionary) {
        dictionary = JSON.parse(dictionary);

        Object.keys(dictionary.movieData.OpenWeekStartDay).forEach(str => {
          if (!["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].includes(str)) {
            optionsArray.push({
              value: "",
              label: this.$locale(`movie.${str}`),
            });
          }
        });
      }

      return optionsArray;
    },
  },
  methods: {
    undisplay_fn(keyName) {
      this.formData[keyName] = !this.formData[keyName]
    },
  },
};
</script>